import type { RouteLocationNormalizedLoaded } from 'vue-router'
import { useGlobalStateStore } from '@library/stores'

/**
 * 當相同 Router Name 的 Full Path 改變時，重新載入頁面
 * @param route Vue-Route
 */
export function useReloadSameRoute(route: RouteLocationNormalizedLoaded) {
  const globalState = useGlobalStateStore()

  // 相同 router name 的頁面，網址或參數改變時，更新 main-layout 的 key，重新載入 view 組件（不含 Layout）
  watch(
    [
      () => route.name,
      () => route.fullPath,
      () => route.params,
      () => route.query
    ],
    (
      [newRouteName, newFullPath, newParams, newQuery],
      [oldRouteName, oldFullPath, oldParams, oldQuery]
    ) => {
      // 如果 route meta 有設定 "當 params 改變時避免重新渲染頁面" 時，且 params 不相同，不重新渲染頁面
      if (
        route.meta.preventRefreshWhenParamsChange &&
        JSON.stringify(newParams) !== JSON.stringify(oldParams)
      ) {
        return
      }

      // 如果 route meta 有設定 "當 query 改變時避免重新渲染頁面" 時，且 query 不相同，不重新渲染頁面
      if (
        route.meta.preventRefreshWhenQueryChange &&
        JSON.stringify(newQuery) !== JSON.stringify(oldQuery)
      ) {
        return
      }

      if (newRouteName === oldRouteName && newFullPath !== oldFullPath) {
        globalState.reloadRouterView()
      }
    },
    {
      deep: true
    }
  )
}
